// extracted by mini-css-extract-plugin
export default {"gigrFields":"styles-scoped__gigrFields--nXUVn","cusField":"styles-scoped__cusField--VTq9D"};